import React, { useCallback } from 'react';
import styled from 'styled-components';

import { StatusLabelProps } from './types';

const StyledContainer = styled.div<Pick<StatusLabelProps<any>, 'backgroundColor'>>`
  padding: 0.416666667rem 1rem;
  line-height: 1;
  border-radius: 16px;
  box-sizing: border-box;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const StyledStatusLabel = styled.span<Pick<StatusLabelProps<any>, 'textColor'>>`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ textColor }) => textColor};
`;

const StatusLabel = <T extends string>({
  className,
  statusLabelClassName,
  statusLabel,
  backgroundColor = '#fff',
  textColor = '#000',
  onClick = () => {},
}: StatusLabelProps<T>) => {
  const handleClick = useCallback(() => {
    onClick(statusLabel);
  }, [statusLabel, onClick]);

  return (
    <StyledContainer backgroundColor={backgroundColor} className={className} onClick={handleClick}>
      <StyledStatusLabel className={statusLabelClassName} textColor={textColor}>
        {statusLabel}
      </StyledStatusLabel>
    </StyledContainer>
  );
};

export default StatusLabel;
